module.exports = __webpack_public_path__ + "img/nick-liefhebber-the-galaxy-knows.3c44b1e.jpg";